import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgZorroAntdModule } from "ng-zorro-antd";
import { HdDetailFormComponent } from "./hd-detail-form.component";

@NgModule({
  imports: [CommonModule, NgZorroAntdModule],
  exports: [HdDetailFormComponent],
  declarations: [HdDetailFormComponent],
})
export class HdDetailFormModule {}
